import { render } from "./PendingOrders.vue?vue&type=template&id=e085c3cc&scoped=true"
import script from "../js/pending-orders.js?vue&type=script&lang=js&external"
export * from "../js/pending-orders.js?vue&type=script&lang=js&external"

import "./PendingOrders.vue?vue&type=style&index=0&id=e085c3cc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e085c3cc"]])

export default __exports__